var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('b-card', {
    staticClass: "border-0 shadow-none",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', [_c('b-row', {
    staticClass: "align-items-center mb-1"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('h5', {
    staticClass: "mb-25"
  }, [_vm._v("Stok Mobil")]), _c('p', {
    staticClass: "text-body mb-0"
  }, [_vm._v(" Pilih barang yang akan dikembalikan ke gudang, lalu isi jumlah pengembalian (minimal 1). ")])]), _c('b-col', {
    staticClass: "mt-1 mt-md-0",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_vm.isSales ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.checkedBarangs.length < 1 || _vm.loading
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.returnBarang($event);
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "CornerUpRightIcon"
    }
  }), _vm._v(" Request Pengembalian Stok "), _vm.checkedBarangs.length ? _c('b-badge', {
    staticClass: "ml-50",
    attrs: {
      "variant": "light-primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.checkedBarangs.length) + " ")]) : _vm._e()], 1) : _vm._e()], 1)], 1), _c('b-row', {
    staticClass: "align-items-end mb-1"
  }, [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Per halaman",
      "label-for": "perPageSelect"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "perPageSelect",
      "size": "sm",
      "options": _vm.pageOptions
    },
    model: {
      value: _vm.perPage,
      callback: function callback($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "5",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Cari",
      "label-for": "filterInput"
    }
  }, [_c('b-input-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filterInput",
      "type": "search",
      "placeholder": "Cari nama / kode barang..."
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function click($event) {
        _vm.filter = '';
      }
    }
  }, [_vm._v(" Clear ")])], 1)], 1)], 1)], 1)], 1), !_vm.loading && !_vm.items.length ? _c('div', {
    staticClass: "text-center text-muted py-4 border rounded"
  }, [_vm._v(" Belum ada stok di mobil. ")]) : _vm._e(), _c('b-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading || _vm.items.length,
      expression: "loading || items.length"
    }],
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "small": "",
      "show-empty": "",
      "empty-text": "Tidak ada data",
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "items": _vm.items,
      "fields": _vm.fields,
      "filter": _vm.tableFilter,
      "filter-included-fields": _vm.filterOn
    },
    on: {
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "head(checkbox)",
      fn: function fn() {
        return [_vm.isSales ? _c('b-form-checkbox', {
          attrs: {
            "disabled": _vm.selectableItems.length < 1
          },
          model: {
            value: _vm.allChecked,
            callback: function callback($$v) {
              _vm.allChecked = $$v;
            },
            expression: "allChecked"
          }
        }) : _c('span', [_vm._v("#")])];
      },
      proxy: true
    }, {
      key: "cell(checkbox)",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm.isSales && item.stok > 0 ? _c('b-form-checkbox', {
          attrs: {
            "value": item
          },
          model: {
            value: _vm.checkedBarangs,
            callback: function callback($$v) {
              _vm.checkedBarangs = $$v;
            },
            expression: "checkedBarangs"
          }
        }) : _vm.isSales ? _c('feather-icon', {
          staticClass: "text-danger",
          attrs: {
            "icon": "SlashIcon"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(no)",
      fn: function fn(_ref2) {
        var index = _ref2.index;
        return [_vm._v(" " + _vm._s((_vm.currentPage - 1) * _vm.perPage + index + 1) + " ")];
      }
    }, {
      key: "cell(kode)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.kode || "-") + " ")];
      }
    }, {
      key: "cell(kategori)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.kategori || "-") + " ")];
      }
    }, {
      key: "cell(satuan)",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm.formatSatuan(item)) + " ")];
      }
    }, {
      key: "cell(stok)",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('strong', [_vm._v(_vm._s(_vm.formatQty(item.stok)))])];
      }
    }, {
      key: "cell(jumlah_retur)",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [item.stok > 0 ? [_c('b-form-input', {
          attrs: {
            "type": "number",
            "size": "sm",
            "min": "1",
            "max": Number(item.stok),
            "state": _vm.qtyState(item)
          },
          on: {
            "input": function input($event) {
              return _vm.clampQty(item);
            }
          },
          model: {
            value: item.jumlah_retur,
            callback: function callback($$v) {
              _vm.$set(item, "jumlah_retur", _vm._n($$v));
            },
            expression: "item.jumlah_retur"
          }
        }), _vm.qtyError(item) ? _c('small', {
          staticClass: "text-danger d-block"
        }, [_vm._v(" " + _vm._s(_vm.qtyError(item)) + " ")]) : _vm._e()] : _c('small', {
          staticClass: "text-danger"
        }, [_vm._v("Stok kosong")])];
      }
    }])
  }), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mt-1"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total " + _vm._s(_vm.totalRows) + " barang")]), _c('b-pagination', {
    staticClass: "my-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "right",
      "size": "sm"
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1), _c('retur-modal', {
    attrs: {
      "items": _vm.checkedBarangs,
      "saving": _vm.loading
    },
    on: {
      "submit": _vm.submit
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }